import { ReactNode } from 'react';

import { IconManagerProps } from '@speeki/icons';

import { BackgroundCircle } from '@components/atoms/BackgroundCircle/BackgroundCircle';
import {
    Container,
    LayoutInner,
    LayoutWrapper,
} from '@components/ions/layouts';
import { Footer, FooterProps } from '@components/molecules/Footer/Footer';
import { Header, HeaderProps } from '@components/organisms/Header/Header';
import { SkeletonHeader } from '@components/organisms/Header/Header.skeleton';

import { LayoutContent } from './FeedbackLayout.styled';

interface FeedbackLayoutProps {
    children: ReactNode;
    className?: string;
    footerProps?: FooterProps;
    headerProps?: HeaderProps;
    iconProps: IconManagerProps;
    isSkeleton?: boolean;
}

export const FeedbackLayout = ({
    children,
    className,
    footerProps,
    headerProps,
    iconProps,
    isSkeleton,
}: FeedbackLayoutProps) => {
    return (
        <LayoutWrapper className={className}>
            <LayoutInner>
                {isSkeleton ? <SkeletonHeader /> : <Header {...headerProps} />}
                <BackgroundCircle iconProps={iconProps} />
                <LayoutContent>
                    <Container>{children}</Container>
                </LayoutContent>
                <Footer {...footerProps} />
            </LayoutInner>
        </LayoutWrapper>
    );
};
